module.exports = __webpack_public_path__ + "img/logo.2aa58ad5.jpg";